import { render, staticRenderFns } from "./APIHarvester.vue?vue&type=template&id=0bb4452e&"
import script from "./APIHarvester.vue?vue&type=script&lang=ts&"
export * from "./APIHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports